import jsQR from "jsqr";

const MAX_SIDE = 1600;

const readPixels = (source: CanvasImageSource, width: number, height: number) => {
  const scale = Math.min(1, MAX_SIDE / Math.max(width, height));
  const canvas = document.createElement("canvas");

  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));

  const context = canvas.getContext("2d", { willReadFrequently: true });

  if (!context) {
    return null;
  }

  context.drawImage(source, 0, 0, canvas.width, canvas.height);

  return context.getImageData(0, 0, canvas.width, canvas.height);
};

/** The text of the QR code in a picture or a video frame, or null when there is none. */
export const decodeQr = (source: CanvasImageSource, width: number, height: number): string | null => {
  const pixels = readPixels(source, width, height);

  if (!pixels) {
    return null;
  }

  return jsQR(pixels.data, pixels.width, pixels.height, { inversionAttempts: "attemptBoth" })?.data ?? null;
};

/** Reads the QR code of an uploaded picture. */
export const decodeQrFromFile = (file: File) =>
  new Promise<string | null>((resolve) => {
    const url = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(decodeQr(image, image.naturalWidth, image.naturalHeight));
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    image.src = url;
  });
